import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {HostingService} from "../../hosting.service";
import {Website} from "../../../website";
import { filter, first } from "rxjs";

@Component({
    selector: 'db-remove-dns-dialog',
    templateUrl: './remove-dns-dialog.component.html',
    styleUrls: ['./remove-dns-dialog.component.scss'],
    standalone: false
})
export class RemoveDnsDialogComponent extends DialogComponent<null, Boolean> implements OnInit {

  @Input() website: Website;
  @Input() zoneId: number;
  @Input() recordId: number;

  public loading: boolean;
  public changes: any;

  constructor(
    private _dialogService: DialogService,
    private _hostingService: HostingService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {

  }

  public cancel(): void {
    this.result = false;
    this.close();
  }


  public confirm(): void {
    this.loading = true;
    this._hostingService.removeZoneRecord( this.zoneId, this.recordId, this.website )
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this.result = true;
          this.close();
        }
        this.loading = false;

      });

  }

}
